"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoardSpaceFiller = BoardSpaceFiller;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_jss_1 = require("react-jss");
const SelectedPieceInfo_1 = require("../SelectedPieceInfo");
const useSelectedPiece_1 = require("../hooks/useSelectedPiece");
const PieceCount_1 = require("./overlays/PieceCount");
const ReadyUpButton_1 = require("./overlays/controls/ReadyUpButton");
const SellPieceButton_1 = require("./overlays/controls/SellPieceButton");
const useStyles = (0, react_jss_1.createUseStyles)({
    filler: ({ size }) => ({
        "aspectRatio": `${size.width} / ${size.height}`,
        "display": "flex",
        "flexDirection": "column",
        "gap": "8px",
        "paddingBottom": "8px",
        "boxSizing": "border-box",
        "@media (orientation: portrait) and (max-width: 400px)": {
            paddingBottom: "4px",
            gap: "4px",
        },
    }),
    row: {
        "display": "flex",
        "flexDirection": "row",
        "justifyContent": "space-between",
        "gap": "8px",
        "@media (orientation: portrait) and (max-width: 400px)": {
            gap: "4px",
        },
    },
    grow: {
        flex: 1,
    },
    half: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
    },
    selectedPiece: {
        "display": "flex",
        "flexDirection": "column",
        "gap": "8px",
        "@media (orientation: portrait) and (max-width: 400px)": {
            gap: "4px",
        },
    },
});
function BoardSpaceFiller({ width, height, }) {
    const styles = useStyles({
        size: { width, height },
    });
    const selectedPiece = (0, useSelectedPiece_1.useSelectedPiece)();
    return (react_1.default.createElement("div", { className: styles.filler },
        react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.row, styles.grow) },
            react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.half, styles.selectedPiece) },
                selectedPiece && react_1.default.createElement(SelectedPieceInfo_1.SelectedPieceInfo, null),
                selectedPiece && react_1.default.createElement(SellPieceButton_1.SellPieceButton, null)),
            react_1.default.createElement("div", { className: styles.half })),
        react_1.default.createElement("div", { className: styles.row },
            react_1.default.createElement("div", { className: styles.half },
                react_1.default.createElement(PieceCount_1.PieceCount, null)),
            react_1.default.createElement("div", { className: styles.half },
                react_1.default.createElement(ReadyUpButton_1.ReadyUpButton, null)))));
}
